import React, { useState } from 'react';
import { FaEye, FaEyeSlash } from 'react-icons/fa';
import logo from 'images/Anuyog logo.png';
import { useLoginMutation } from 'api/authApi';
import { useNavigate } from 'react-router-dom';
import { useUser } from 'context/UserContext';
import './login.css';

const Login = () => {
    const { setName, setEmail } = useUser();

    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');
    const [showPassword, setShowPassword] = useState(false);
    const [formErrors, setFormErrors] = useState({});

    const [login, { isLoading, error }] = useLoginMutation();
    const navigate = useNavigate();

    const togglePassword = () => setShowPassword(prev => !prev);

    const handleSubmit = async e => {
        e.preventDefault();

        const errors = {};
        if (!username.trim()) errors.username = 'Username is required';
        if (!password.trim()) errors.password = 'Password is required';

        if (Object.keys(errors).length > 0) {
            setFormErrors(errors);
            return;
        }
        setFormErrors({});

        try {
            const res = await login({ username, password }).unwrap();

            localStorage.setItem('token', res.token);
            localStorage.setItem('user', JSON.stringify({ name: res.name, email: res.email }));

            setName(res.name);
            setEmail(res.email);

            navigate('/dashboard', { state: { user: res } });
        } catch (err) {
            console.error('Login failed:', err);
        }
    };

    return (
        <div className="login-page-container">
            <div className="login-glass-card">
                <img src={logo} alt="Logo" className="login-logo" />
                <h2 className="login-title">
                    Welcome to Anuyog Admin
                </h2>

                <form onSubmit={handleSubmit}>
                    <div className="login-form-group">
                        <label className="login-label">Username</label>
                        <input
                            type="text"
                            value={username}
                            onChange={e => setUsername(e.target.value)}
                            placeholder="Enter your username"
                            className={`login-input ${formErrors.username ? 'login-input-error' : ''}`}
                        />
                        {formErrors.username && (
                            <p className="login-error-text">{formErrors.username}</p>
                        )}
                    </div>

                    <div className="login-form-group">
                        <label className="login-label">Password</label>
                        <input
                            type={showPassword ? 'text' : 'password'}
                            value={password}
                            onChange={e => setPassword(e.target.value)}
                            placeholder="Password"
                            className={`login-input ${formErrors.password ? 'login-input-error' : ''}`}
                        />
                        <button
                            type="button"
                            className="login-password-toggle"
                            onClick={togglePassword}
                            aria-label="Toggle password visibility"
                        >
                            {showPassword ? <FaEyeSlash size={18} /> : <FaEye size={18} />}
                        </button>
                        {formErrors.password && (
                            <p className="login-error-text">{formErrors.password}</p>
                        )}
                    </div>

                    {error && (
                        <p className="login-error-text" style={{ textAlign: 'center', marginBottom: '1rem', fontSize: '0.875rem' }}>
                            Invalid username or password.
                        </p>
                    )}

                    <button
                        type="submit"
                        disabled={isLoading}
                        className="login-btn-submit"
                    >
                        {isLoading ? 'Signing In...' : 'Sign In'}
                    </button>
                </form>
            </div>
        </div>
    );
};

export default Login;
